const API_URL = import.meta.env.VITE_API_URL
const ONBOARDING_REQUEST_TIMEOUT_MS = 8_000

function getToken() {
  try {
    const raw = localStorage.getItem('auth')
    const parsed = JSON.parse(raw)
    if (parsed?.token && parsed.expiresAt > Date.now()) {
      return parsed.token
    }
  } catch {
    return null
  }
  return null
}

function authHeaders(includeJson = true) {
  const token = getToken()
  const headers = {}
  if (token) headers.Authorization = `Bearer ${token}`
  if (includeJson) headers['Content-Type'] = 'application/json'
  return headers
}

async function parseError(res, fallback = 'Request failed') {
  try {
    const data = await res.clone().json()
    if (typeof data?.error === 'string' && data.error.trim()) {
      return data.error
    }
  } catch {
    // Ignore JSON parsing errors.
  }

  try {
    const text = await res.text()
    if (text?.trim()) return text.trim()
  } catch {
    // Ignore plain text parsing errors.
  }

  return fallback
}

async function fetchWithTimeout(url, options = {}, timeoutMs = ONBOARDING_REQUEST_TIMEOUT_MS) {
  if (typeof AbortController === 'undefined') {
    return fetch(url, options)
  }

  const controller = new AbortController()
  const timeoutId = setTimeout(() => {
    controller.abort(new Error('Onboarding request timed out'))
  }, timeoutMs)

  try {
    return await fetch(url, {
      ...options,
      signal: controller.signal,
    })
  } catch (error) {
    const isAbortError = error?.name === 'AbortError' || controller.signal.aborted
    if (isAbortError) {
      throw new Error('Onboarding request timed out')
    }
    throw error
  } finally {
    clearTimeout(timeoutId)
  }
}

export async function getOnboardingSnapshot() {
  const res = await fetchWithTimeout(`${API_URL}/v2/me/onboarding`, {
    headers: authHeaders(),
  })

  if (!res.ok) {
    throw new Error(await parseError(res, 'Failed to fetch onboarding snapshot'))
  }

  return res.json()
}

export async function dismissOnboarding() {
  const res = await fetch(`${API_URL}/v2/me/onboarding/dismiss`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify({}),
  })

  if (!res.ok) {
    throw new Error(await parseError(res, 'Failed to dismiss onboarding'))
  }

  return res.json()
}
